import loaded from '@/scripts/helpers/loaded.js';
import { interceptInstallmentsCheckout } from '@/scripts/patches/shopPayInstallmentsCheckout.js';

// Keep the Shop Pay Installments banner on the selected variant: the widget reads its own
// variant-id attribute, the hidden input is what the banner's form would post.
function syncPaymentTerms(id) {
  if (!id) return;
  const input = document.querySelector('#product-form-installment [name="id"]');
  if (input) input.value = id;
  document.querySelector('shopify-payment-terms')?.setAttribute('variant-id', String(id));
}

let _swiperPromise;
const loadSwiper = () => {
  if (!_swiperPromise) {
    _swiperPromise = Promise.all([import('swiper/core'), import('swiper/modules')]).then(
      ([core, modules]) => ({
        Swiper: core.default,
        Navigation: modules.Navigation,
        Pagination: modules.Pagination,
        Thumbs: modules.Thumbs,
        EffectFade: modules.EffectFade,
      })
    );
  }
  return _swiperPromise;
};

let _glightboxPromise;
const loadGLightbox = () => {
  if (!_glightboxPromise) {
    _glightboxPromise = Promise.all([
      import('glightbox'),
      import('@/scripts/contants/glightbox.js'),
    ]).then(([gl, consts]) => ({
      GLightbox: gl.default,
      customLightboxHTML: consts.customLightboxHTML,
      customSlideHTML: consts.customSlideHTML,
    }));
  }
  return _glightboxPromise;
};

function isVariantUndefined() {
  return window.location.href.includes('variant=undefined');
}

// SCROLL
document.addEventListener('scroll', function () {
  var scrollTop = parseInt(document.documentElement.scrollTop || document.body.scrollTop);
  var frequentlySection = document.getElementById('frequently__section');
  var productTabs = document.querySelector('.product--tabs');
  var scrollTo;

  if (!frequentlySection) {
    scrollTo = productTabs ? parseInt(productTabs.offsetTop) : 0;
  } else {
    scrollTo = parseInt(frequentlySection.offsetTop);
  }

  var heightScreen = parseInt(window.innerHeight),
    scrollHeightTo = scrollTop + heightScreen,
    fixedAdd = document.querySelector('.fixed__addtocart__product--parent'),
    hasClass = fixedAdd ? fixedAdd.classList.contains('active') : false;

  if (scrollHeightTo > scrollTo) {
    if (!hasClass && fixedAdd) {
      fixedAdd.classList.add('active');
    }
  } else {
    if (fixedAdd) {
      fixedAdd.classList.remove('active');
    }
  }
});

window.addEventListener('load', function () {
  document.querySelectorAll('.js__upsell--click').forEach(function (button) {
    button.addEventListener('click', function (e) {
      var hasClass = this.classList.contains('active');
      if (hasClass) {
        this.classList.remove('active');
      } else {
        this.classList.add('active');
      }
    });
  });
});

function updateAddToCartButton() {
  if (isVariantUndefined()) {
    document.querySelectorAll('.js--sumbit__button').forEach(function (btn) {
      btn.disabled = true;
    });
  } else {
    document.querySelectorAll('.js--sumbit__button').forEach(function (btn) {
      btn.disabled = false;
    });
  }
}

loaded(function () {
  let selectItem = document.querySelector('[data-select-item="1"]');

  if (selectItem) {
    var activeItem = selectItem.options[selectItem.selectedIndex].getAttribute('data-value');
    if (activeItem) {
      var targetElement = document.querySelector(
        `.select--item.second[data-index="${activeItem}"]`
      );
      if (targetElement) {
        targetElement.classList.add('show');
      }
    }
  }

  document.querySelectorAll('.js__addtocart__fixed').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.querySelector('.js__form--addtocart');
      if (form) {
        form.submit();
      }
    });
  });

  // Pre-Order
  document.querySelectorAll('.js__checkbox--shipping__parent').forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      var hasActive = this.classList.contains('active'),
        btnShipping = document.querySelector('.absolute__shipping--parent');
      if (!hasActive) {
        this.classList.add('active');
        if (btnShipping) {
          btnShipping.classList.add('active');
        }
      }
    });
  });

  document.querySelectorAll('.js__show__checkbox__item.active').forEach(function (element) {
    element.style.display = 'block';
  });

  loadSwiper().then(({ Swiper, Navigation, Pagination, Thumbs, EffectFade }) => {
    const thumbnailSlider = new Swiper('.js--nav__product__mobile--slider', {
      slidesPerView: 'auto',
      allowTouchMove: true,
    });

    const mainSlider = new Swiper('.js--product__mobile--slider', {
      slidesPerView: 1,
      effect: 'fade',
      allowTouchMove: true,
      loop: false,
      navigation: {
        nextEl: '.js--product__mobile--slider .swiper-button-next',
        prevEl: '.js--product__mobile--slider .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      thumbs: {
        swiper: thumbnailSlider,
      },
      modules: [Navigation, Pagination, Thumbs, EffectFade],
    });

    window.mainSlider = mainSlider;

    const mobileSlider = document.querySelector('.js--product__mobile--slider');
    const navSlider = document.querySelector('.js--nav__product__mobile--slider');
    if (mobileSlider) mobileSlider.style.opacity = '1';
    if (navSlider) navSlider.style.opacity = '1';
  });

  document.querySelectorAll('.qty--btn__js').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var hasPlus = this.classList.contains('icon-plus'),
        hasMinus = this.classList.contains('icon-minus'),
        parent = this.closest('.parent--qty__js--form'),
        input = parent ? parent.querySelector('.qty--item__input--form') : null,
        val = input ? parseInt(input.value) : 0;
      if (hasPlus && input) {
        val = val + 1;
        input.value = val;
      } else if (hasMinus && input) {
        if (val > 1) {
          val = val - 1;
          input.value = val;
        }
      }
    });
  });

  document.querySelectorAll('.js--smaller--icon').forEach(function (icon) {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      var id = this.getAttribute('data-id'),
        hasClass = this.classList.contains('active--item'),
        parent = this.closest('.inner--product--main'),
        item = parent ? parent.querySelector('.js--parent__scroll[data-id="' + id + '"]') : null;
      if (!hasClass) {
        document.querySelectorAll('.js--smaller--icon').forEach(function (el) {
          el.classList.remove('active--item');
        });
        this.classList.add('active--item');
      }
    });
  });

  document.querySelectorAll('.change--selectProduct').forEach(function (select) {
    select.addEventListener('change', function (e) {
      console.log('Change detected', e);

      e.preventDefault();

      var main_parent = this.closest('.parent__custom--options--select'),
        hasClassChanges = main_parent ? main_parent.classList.contains('without__changes') : false,
        closest = this.closest('.select--item'),
        hasClassClosestF = closest ? closest.classList.contains('first') : false,
        hasClassClosestS = closest ? closest.classList.contains('second') : false,
        hasClassClosestSN = closest ? closest.classList.contains('hasoptionSecond') : false,
        hasClassClosestT = closest ? closest.classList.contains('third') : false,
        hasClassClosestTN = closest ? closest.classList.contains('hasoptionThird') : false,
        parent = this.closest('.parent--content--product__main'),
        select1 = parent ? parent.querySelector('[data-select-item="1"]') : null,
        val1 = select1 ? select1.value : '',
        val1Handle =
          select1 && select1.selectedIndex >= 0
            ? select1.options[select1.selectedIndex].getAttribute('data-value')
            : '',
        select = parent ? parent.querySelector('.product-single__variants') : null;

      if (hasClassClosestF) {
        document.querySelectorAll('.select--item.second').forEach(function (item) {
          item.classList.remove('show');
        });
        var selectSecondParent = document.querySelector(
            `.select--item[data-index="${val1Handle}"]`
          ),
          selectSecond = selectSecondParent
            ? selectSecondParent.querySelector('select.change--selectProduct')
            : null;
        var selectThirdParent = document.querySelector(`.select--item[data-index="${val1Handle}"]`),
          selectThird = selectThirdParent
            ? selectThirdParent.querySelector('select.change--selectProduct')
            : null;
        if (selectSecondParent) {
          selectSecondParent.classList.add('show');
        }
        var val2 =
          selectSecond && selectSecond.selectedIndex >= 0
            ? selectSecond.options[selectSecond.selectedIndex].value
            : '';
      }

      if (hasClassChanges) {
        var select2 = document.querySelector('[data-select-item="2"]');
        var select3 = document.querySelector('[data-select-item="3"]');
        var val2 =
          select2 && select2.selectedIndex >= 0 ? select2.options[select2.selectedIndex].value : '';
        var val3 =
          select3 && select3.selectedIndex >= 0 ? select3.options[select3.selectedIndex].value : '';
      }

      if (hasClassClosestS) {
        var val2 = this.selectedIndex >= 0 ? this.options[this.selectedIndex].value : '';
      }
      if (hasClassClosestT) {
        var val3 = this.selectedIndex >= 0 ? this.options[this.selectedIndex].value : '';
      }

      if (typeof val1 === 'undefined') {
        var val1 = '';
      }
      if (typeof val2 === 'undefined') {
        var val2 = '';
      }
      if (typeof val3 === 'undefined') {
        var val3 = '';
      }

      var option = select
          ? select.querySelector(
              'option[data-option1="' +
                val1 +
                '"][data-option2="' +
                val2 +
                '"][data-option3="' +
                val3 +
                '"]'
            )
          : null,
        id = option ? option.value : '',
        price = option ? option.getAttribute('data-price') : '',
        comparePrice = option ? option.getAttribute('data-compare-price') : '',
        priceParent = parent ? parent.querySelector('.js--price--main') : null,
        comparePriceParent = parent ? parent.querySelector('.js--compare-price--main') : null,
        available = option ? option.getAttribute('data-available') : '',
        disableButton = parent ? parent.querySelector('.js--disable__submit') : null,
        submitButton = parent ? parent.querySelector('.js--sumbit__button') : null,
        hasClassButton = disableButton ? disableButton.classList.contains('show') : false,
        dataImgID = option ? option.getAttribute('data-image-id') : '',
        ImgFixed = option ? option.getAttribute('data-image-fixed') : '';

      console.log('available', available);

      if (available == 'false') {
        if (!hasClassButton && disableButton) {
          disableButton.classList.add('show');
        }
        if (submitButton) {
          submitButton.classList.add('hidden');
        }
      } else if (available == 'true') {
        if (hasClassButton && disableButton) {
          disableButton.classList.remove('show');
        }
        if (submitButton) {
          submitButton.classList.remove('hidden');
        }
      }

      if (ImgFixed != '') {
        var fixedImg = document.querySelector('.js__fixed__img');
        if (fixedImg) {
          fixedImg.innerHTML = '<img src="' + ImgFixed + '" alt="" class="fixed__image__product">';
        }
      }
      var productPriceFixed = document.getElementById('ProductPrice__fixed');
      var comparePriceFixed = document.getElementById('ComparePrice__fixed');
      if (productPriceFixed) productPriceFixed.innerHTML = price;
      if (comparePriceFixed) comparePriceFixed.innerHTML = comparePrice;
      if (priceParent) priceParent.innerHTML = price;
      if (comparePriceParent) comparePriceParent.innerHTML = comparePrice;
      if (select) select.value = id;
      syncPaymentTerms(id);

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        id;
      window.history.replaceState({ path: newurl }, '', newurl);

      setTimeout(updateAddToCartButton, 50); // 50 milliseconds delay

      var imgProduct = document.querySelector(
        '.img--main__product[data-image-id="' + dataImgID + '"]'
      );
      if (imgProduct) {
        // mobile js
        var mobItem = document.querySelector(
            '.js__item__show--img[data-image-id="' + dataImgID + '"]'
          ),
          count = mobItem ? mobItem.getAttribute('data-count') : 0,
          sliderMob = document.querySelector('.js--product__mobile--slider');

        if (typeof window.mainSlider !== 'undefined' && count) {
          window.mainSlider.slideTo(parseInt(count));
        }

        // Smooth scroll
        var targetY = imgProduct.offsetTop - 106;
        window.scrollTo({
          top: targetY,
          behavior: 'smooth',
        });

        setTimeout(function () {
          var imageProduct = imgProduct.closest('.js--image__product');
          if (imageProduct) {
            imageProduct.classList.add('target-highlight');
            setTimeout(function () {
              imageProduct.classList.remove('target-highlight');
              setTimeout(function () {
                imageProduct.classList.add('target-highlight');
                setTimeout(function () {
                  imageProduct.classList.remove('target-highlight');
                }, 1500);
              }, 300);
            }, 1500);
          }
        }, 1000);
      }
    });
  });
});

loaded(function () {
  const searchParams = new URLSearchParams(window.location.search);
  if (!searchParams?.has('variant')) {
    return;
  }

  const variant = searchParams.get('variant');
  if (!variant) {
    return;
  }

  if (variant !== 'undefined') {
    return;
  }

  searchParams.delete('variant');
  const searchParamsString = searchParams.toString();

  window.location.href = `${window.location.origin}${window.location.pathname}${searchParamsString ? `?${searchParamsString}` : ''}`;
});

loaded(function () {
  const hasVideoMedia = !!document.querySelector(
    '.product--media--video, .gslide-inline video, [data-glightbox-type="video"]'
  );
  const GALLERY_SELECTORS =
    '.magnified__link--images_mobile a.js__magnify_mobile, .magnified__link--images a.js--image__product';

  const initLightboxes = () =>
    loadGLightbox().then(({ GLightbox, customLightboxHTML, customSlideHTML }) => {
      const baseConfig = selector => {
        const config = {
          openEffect: 'zoom',
          closeEffect: 'fade',
          selector,
          touchNavigation: true,
          loop: true,
          autoplayVideos: false,
          cssEffects: {
            fade: { in: 'fadeIn', out: 'fadeOut' },
            zoom: { in: 'zoomIn', out: 'zoomOut' },
          },
          lightboxHTML: customLightboxHTML,
          slideHTML: customSlideHTML,
        };
        if (hasVideoMedia) {
          config.videosWidth = 'auto';
          config.plyr = {
            config: {
              ratio: '16:9',
              muted: false,
              hideControls: false,
              youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3 },
              vimeo: {
                byline: false,
                portrait: false,
                title: false,
                speed: true,
                transparent: false,
              },
            },
          };
        }
        return config;
      };

      const attachVideoHandlers = lb => {
        lb.on('open', () => {
          const activeSlide = document.querySelector('.gslide-inline video');
          if (activeSlide) {
            activeSlide.muted = false;
            activeSlide.play();
          }
        });
        lb.on('close', () => {
          document.querySelectorAll('.gslide-inline video').forEach(v => {
            v.muted = true;
            v.pause();
          });
        });
        lb.on('slide_changed', ({ prev, current }) => {
          const prevVideo = prev.querySelector('video');
          const currentVideo = current.querySelector('video');
          if (prevVideo) {
            prevVideo.muted = true;
            prevVideo.pause();
          }
          if (currentVideo) {
            currentVideo.muted = false;
            currentVideo.play();
          }
        });
      };

      const mobileLightbox = GLightbox(
        baseConfig('.magnified__link--images_mobile a.js__magnify_mobile')
      );
      attachVideoHandlers(mobileLightbox);
      const desktopLightbox = GLightbox(
        baseConfig('.magnified__link--images a.js--image__product')
      );
      attachVideoHandlers(desktopLightbox);

      return { mobileLightbox, desktopLightbox };
    });

  let lightboxReady = null;
  const onFirstInteract = e => {
    const link = e.target.closest(GALLERY_SELECTORS);
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    document.removeEventListener('click', onFirstInteract, true);
    if (!lightboxReady) lightboxReady = initLightboxes();
    lightboxReady.then(() => link.click());
  };
  document.addEventListener('click', onFirstInteract, true);

  const idle = window.requestIdleCallback || (cb => setTimeout(cb, 1500));
  idle(
    () => {
      if (!lightboxReady) lightboxReady = initLightboxes();
    },
    { timeout: 3000 }
  );

  // Shop Pay keeps its only control (the question mark) inside its shadow root, so the whole bar forwards to it
  function makeTermsBarClickable() {
    const container = document.querySelector('.shopify-payment-terms');
    if (!container || container.dataset.clickable) return;
    container.dataset.clickable = 'true';
    container.addEventListener('click', event => {
      const control = document
        .querySelector('shopify-payment-terms')
        ?.shadowRoot?.querySelector('button');
      if (!control) return;
      // their own control already opens the popup; the rest of the bar, text included, is forwarded to it
      if (event.composedPath().includes(control)) return;
      control.click();
    });
  }

  function replaceShopPayText() {
    const shopifyPaymentTerms = document.querySelector('shopify-payment-terms');
    const container = document.querySelector('.shopify-payment-terms');

    if (shopifyPaymentTerms && shopifyPaymentTerms.shadowRoot) {
      const shadowRoot = shopifyPaymentTerms.shadowRoot;
      const findAndReplace = () => {
        const allElements = shadowRoot.querySelectorAll('*');
        allElements.forEach(element => {
          const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
          let node;
          while ((node = walker.nextNode())) {
            if (node.textContent.includes('Check your purchasing power')) {
              node.textContent = node.textContent.replace(
                'Check your purchasing power',
                'Check your financing options'
              );
            }
          }
        });

        if (container) {
          container.classList.add('visible');
        }
      };

      findAndReplace();

      const observer = new MutationObserver(findAndReplace);
      observer.observe(shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  // the shadow root exists only once Shop Pay has upgraded the element, which is well after 500ms
  if (document.querySelector('shopify-payment-terms')) {
    makeTermsBarClickable();
    customElements
      .whenDefined('shopify-payment-terms')
      .then(() => requestAnimationFrame(replaceShopPayText));
  }
});

loaded(interceptInstallmentsCheckout);
